module.exports = __webpack_public_path__ + "static/img/custom-weathering-steel-wayfinding-sign.811c039.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/kiosks/custom-weathering-steel-wayfinding-sign.jpg
// module id = 741
// module chunks = 0